<template>
  <div>
    <el-card class="box-card">
      <div class="title mt20">发货</div>
      <el-form :model="dlsorderinvoice" ref="dlsorderinvoiceRef" label-width="82px">
        <el-form-item v-for="(item,index) in dlsorderinvoice.optionsproduct" label="" class="addAdminFormLong">
          <div class="productdata1">
            <div class="productdata2">
              产品名称:
              <el-input v-model="item.Name" placeholder="" style="width: 20%" disabled></el-input>
              出货备注:
              <el-input v-model="item.Beizhuout" placeholder="" style="width: 20%" disabled></el-input>
              数量:
              <el-input v-model="item.Num" placeholder="" style="width: 20%"></el-input>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="配送方式" class="addAdminForm">
          <el-select v-model="dlsorderinvoice.sendtype" placeholder="请选择" style="width: 100%">
            <el-option label="邮寄" value="0"></el-option>
            <el-option label="上门自提" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流公司" class="addAdminForm" v-if="dlsorderinvoice.sendtype == 0">
          <el-input v-model="dlsorderinvoice.logisticsname" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="物流单号" class="addAdminForm" v-if="dlsorderinvoice.sendtype == 0">
          <el-input v-model="dlsorderinvoice.logisticsid" placeholder=""></el-input>
        </el-form-item>
        <el-form-item class="mt20">
          <el-button type="primary" @click="clicksave">发货</el-button>
          <el-button type="info" @click="clickback">返回</el-button>
        </el-form-item>
      </el-form>

      <div class="title mt20">发货记录</div>
      <el-table :data="listlog" border stripe class="mt15">
        <el-table-column prop="Productlist" label="清单" min-width="25%"></el-table-column>
        <el-table-column prop="Statuss" label="状态" min-width="5%"></el-table-column>
        <el-table-column prop="Sendtypes" label="配送方式" min-width="5%"></el-table-column>
        <el-table-column prop="Logisticsname" label="物流公司" min-width="10%"></el-table-column>
        <el-table-column prop="Logisticsid" label="物流单号" min-width="10%"></el-table-column>
        <el-table-column prop="Createusername" label="发货人" min-width="5%"></el-table-column>
        <el-table-column prop="Createtime" label="操作时间" min-width="15%"></el-table-column>
        <el-table-column prop="operation" label="操作" min-width="10%">
          <template v-slot="scope">
            <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      dlsorderinvoice: {
        optionsproduct: [],
        sendtype: '0',
        logisticsname: '',
        logisticsid: ''
      },
      listlog: [],
      listbeizhulog: [],
      orderid: null
    }
  },
  methods: {
    LoadData (parentdata) {
      this.orderid = parentdata.params.orderid
      this.GetNaoxjStockSaleSubByOrderid()
      this.apiGetNaoxjStockSaleSendlist()
    },
    clickback () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiAddNaoxjStockSaleSend()
    },
    clickdelete (row) {
      this.$confirm('是否删除此发货记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.DeleteNaoxjStockSaleSend(row.Orderid, row.Sendid)
      })
    },
    GetNaoxjStockSaleSubByOrderid: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: this.orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetNaoxjStockSaleSubByOrderid, Qs.stringify(data))
        .then(function (response) {
          console.log(response.data)
          if (response.data.Code === 200) {
            that.dlsorderinvoice.optionsproduct = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddNaoxjStockSaleSend: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: this.orderid,
        productlist: JSON.stringify(this.dlsorderinvoice.optionsproduct),
        sendtype: this.dlsorderinvoice.sendtype,
        logisticsname: this.dlsorderinvoice.logisticsname,
        logisticsid: this.dlsorderinvoice.logisticsid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddNaoxjStockSaleSend, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGetNaoxjStockSaleSendlist()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetNaoxjStockSaleSendlist: function (type, parentid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: this.orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetNaoxjStockSaleSendlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.listlog = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    DeleteNaoxjStockSaleSend: function (orderid, sendid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: orderid,
        sendid: sendid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DeleteNaoxjStockSaleSend, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGetNaoxjStockSaleSendlist()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select1 {
    width: 109px;
    margin-right: 15px;
}
.speed {
    width: 440px;
    margin-right: 15px;
}
.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}
</style>
